/**
 * Kimlik doğrulama formu bileşeni
 * Giriş ve kayıt formlarını içerir
 */

import { authService, userService } from '../services/firebase.js';

export default class AuthForm {
  constructor(container) {
    this.container = container;
    this.isLoginMode = true; // true: giriş formu, false: kayıt formu
    
    this.render();
    this.attachEventListeners();
  }
  
  render() {
    const formTitle = this.isLoginMode ? 'Giriş Yap' : 'Kaydol';
    const switchText = this.isLoginMode 
      ? 'Hesabınız yok mu? <a href="#" id="switch-to-register">Kaydolun</a>' 
      : 'Zaten hesabınız var mı? <a href="#" id="switch-to-login">Giriş yapın</a>';
    
    this.container.innerHTML = `
      <div class="auth-form fade-in">
        <h2 class="form-title">${formTitle}</h2>
        <form id="auth-form">
          ${!this.isLoginMode ? `
            <div class="input-group">
              <label for="displayName" class="input-label">Kullanıcı Adı</label>
              <input type="text" id="displayName" class="input-field" required>
            </div>
          ` : ''}
          
          <div class="input-group">
            <label for="email" class="input-label">E-posta</label>
            <input type="email" id="email" class="input-field" required>
          </div>
          
          <div class="input-group">
            <label for="password" class="input-label">Şifre</label>
            <input type="password" id="password" class="input-field" required>
          </div>
          
          <button type="submit" class="auth-button">${formTitle}</button>
        </form>
        
        <div class="auth-switch">
          ${switchText}
        </div>
        
        <div id="auth-error" class="auth-error"></div>
      </div>
    `;
  }
  
  attachEventListeners() {
    // Form gönderme işlevi
    const authForm = document.getElementById('auth-form');
    authForm.addEventListener('submit', (e) => this.handleFormSubmit(e));
    
    // Form tipini değiştirme işlevi
    const switchToRegister = document.getElementById('switch-to-register');
    const switchToLogin = document.getElementById('switch-to-login');
    
    if (switchToRegister) {
      switchToRegister.addEventListener('click', (e) => {
        e.preventDefault();
        this.isLoginMode = false;
        this.render();
        this.attachEventListeners();
      });
    }
    
    if (switchToLogin) {
      switchToLogin.addEventListener('click', (e) => {
        e.preventDefault();
        this.isLoginMode = true;
        this.render();
        this.attachEventListeners();
      });
    }
  }
  
  async handleFormSubmit(e) {
    e.preventDefault();
    
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    
    try {
      if (this.isLoginMode) {
        // Giriş işlemi
        await authService.login(email, password);
      } else {
        // Kayıt işlemi
        const displayName = document.getElementById('displayName').value;
        await authService.register(email, password, displayName);
      }
    } catch (error) {
      this.showError(this.getErrorMessage(error));
    }
  }
  
  showError(message) {
    const errorElement = document.getElementById('auth-error');
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
    }
  }
  
  getErrorMessage(error) {
    // Firebase hata kodlarını kullanıcı dostu mesajlara çevir
    const errorCode = error.code;
    
    const errorMessages = {
      'auth/email-already-in-use': 'Bu e-posta adresi zaten kullanılıyor.',
      'auth/invalid-email': 'Geçersiz e-posta adresi.',
      'auth/user-disabled': 'Bu kullanıcı hesabı devre dışı bırakılmış.',
      'auth/user-not-found': 'Bu e-posta adresine sahip bir kullanıcı bulunamadı.',
      'auth/wrong-password': 'Yanlış şifre.',
      'auth/weak-password': 'Şifre en az 6 karakter olmalıdır.',
      'auth/operation-not-allowed': 'Bu işlem şu anda izin verilmiyor.',
      'auth/account-exists-with-different-credential': 'Bu e-posta adresi başka bir hesaba bağlı.'
    };
    
    return errorMessages[errorCode] || error.message || 'Bir hata oluştu. Lütfen tekrar deneyin.';
  }
}

// Sayfa yüklendiğinde auth formunu başlat
export function initAuthForm() {
  const authContainer = document.getElementById('auth-container');
  if (authContainer) {
    return new AuthForm(authContainer);
  }
  return null;
} 